/** =========================================================
 * Module: load-css.js
 * Request and load into the current page a css file
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.utils')
    .directive('loadCss', loadCss);

  function loadCss() {
    var directive = {
      link: link,
      restrict: 'A'
    };

    return directive;

    function link(scope, element, attrs) {
      element.on('click', function (e) {
        if (element.is('a')) {
          e.preventDefault();
        }

        var uri = attrs.loadCss;
        var cssLink;

        if (uri) {
          cssLink = createLink(uri);
          if (!cssLink) {
            $.error('Error creating stylesheet link element.');
          }
        } else {
          $.error('No stylesheet location defined.');
        }
      });
    }

    function createLink(uri) {
      var linkId = 'autoloaded-stylesheet';
      var oldLink = $('#' + linkId).attr('id', linkId + '-old');

      $('head').append($('<link/>').attr({
        'id': linkId,
        'rel': 'stylesheet',
        'href': uri
      }));

      if (oldLink.length) {
        oldLink.remove();
      }

      return $('#' + linkId);
    }
  }
})();
